import React, { useContext } from 'react'

import ContentMenu from 'components/DashBoard/ContentMenu'
import ContentBin from 'components/DashBoard/ContentBin'
import AuthContext from 'store/AuthContext'
import Forbidden from '../staticPages/Forbidden'
import styles from './pages.module.scss'

const DashBoard = () => {
  const {
    state: { auth },
  } = useContext(AuthContext)

  return auth ? (
    <div className={styles.dashBoardContainer}>
      <ContentMenu />
      <ContentBin />
    </div>
  ) : (
    <Forbidden />
  )
}

export default DashBoard
